import {Injectable} from "@angular/core";
import {Controls} from "three";
import {ViewPortCamera} from "./camera.service";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";

export type ViewPortControl<T> = T extends Controls<any> ? T : never;
export type ControlCongif = {
    camera?: ViewPortCamera<any>,
    viewPort?: HTMLElement
}

@Injectable({providedIn: 'root'})
export class ControlsService {

    strategies: ViewPortControl<any> = {
        orbit: this.provideOrbitControls
    }

    public provideControls(type: string, config: ControlCongif): ViewPortControl<any> {
        return this.strategies[type](config);
    }

    private provideOrbitControls(args: ControlCongif): OrbitControls {
        if(!args.camera || !args.viewPort){ throw new Error('OrbitControls need a camera and a viewPort'); }
        const controls = new OrbitControls(args.camera, args.viewPort);
        controls.enableDamping = true;
        controls.enablePan = true;
        controls.minPolarAngle = 0.8;
        controls.maxPolarAngle = 2.4;
        controls.dampingFactor = 0.2;
        controls.rotateSpeed = 0.6;
        return controls;
    }

}